/*
 * Multi-select finish swatch grid: lets a customer pick several real
 * variants (one qty each) and add them to the cart in a single request,
 * since Dawn's stock variant/cart-add flow only supports one variant at a time.
 */
(function () {
  function init(picker) {
    var swatches = Array.from(picker.querySelectorAll('[data-sl-multi-swatch]'));
    var summary = picker.querySelector('[data-sl-multi-summary]');
    var label = picker.querySelector('[data-sl-multi-label]');
    var quoteCta = picker.closest('form') && picker.closest('form').querySelector('[data-sl-multi-submit]');
    if (!quoteCta) return;

    var submitButton = quoteCta;
    var form = picker.closest('form');
    var errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    var errorMessage = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var selected = new Map();

    function updateUI() {
      var titles = Array.from(selected.values());
      if (titles.length === 0) {
        summary.textContent = 'Select one or more';
        label.textContent = 'No finishes selected yet';
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.disabled = true;
      } else {
        summary.textContent = titles.length + ' selected';
        label.textContent = titles.join(', ');
        submitButton.removeAttribute('aria-disabled');
        submitButton.disabled = false;
      }
    }

    swatches.forEach(function (swatch) {
      if (swatch.disabled) return;

      swatch.addEventListener('click', function () {
        var id = swatch.dataset.variantId;
        var title = swatch.dataset.variantTitle;
        var isActive = swatch.classList.toggle('sl-swatch--active');
        swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (isActive) {
          selected.set(id, title);
        } else {
          selected.delete(id);
        }
        updateUI();
      });
    });

    function handleErrorMessage(message) {
      if (!errorWrapper) return;
      errorWrapper.toggleAttribute('hidden', !message);
      if (message && errorMessage) errorMessage.textContent = message;
    }

    submitButton.addEventListener('click', function () {
      if (submitButton.getAttribute('aria-disabled') === 'true' || selected.size === 0) return;

      handleErrorMessage(false);
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');

      var items = Array.from(selected.keys()).map(function (id) {
        return { id: id, quantity: 1 };
      });

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(
        cart
          ? { items: items, sections: cart.getSectionsToRender().map(function (s) { return s.id; }), sections_url: window.location.pathname }
          : { items: items }
      );

      fetch(routes.cart_add_url, config)
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            handleErrorMessage(response.description || response.message);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sl-multi-finish-cart' });

          var rendered = false;
          if (cart) {
            try {
              cart.renderContents(response);
              rendered = true;
            } catch (e) {
              console.error(e);
            }
          }
          if (!rendered) window.location = routes.cart_url;
        })
        .catch(function (e) {
          console.error(e);
        })
        .finally(function () {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    });

    updateUI();
  }

  document.querySelectorAll('[data-sl-multi-picker]').forEach(init);
})();
